import { Alert, Button, Content, Split, SplitItem, Stack, StackItem } from "@patternfly/react-core";
import type { FC } from "react";
import { useProductMetadata } from "../../hooks/useProductMetadata";
import { ProductComponentsRequirements } from "../ProductComponents/ProductComponentsRequirements";
import ProductComponentsTable from "../ProductComponents/ProductComponentsTable";
import type { ICertAndValidationProps } from "./common-interfaces";

interface AddComponentsProps extends ICertAndValidationProps {
	goToSupportStatements: () => void;
}

const AddComponents: FC<AddComponentsProps> = ({ onNext, goToSupportStatements }) => {
	const {
		productVersionsData,
		componentMetadata: { hasValidated, hasCertified },
		activeCertificationListState,
	} = useProductMetadata();
	return (
		<Stack hasGutter={true}>
			<StackItem>
				<Content>
					<Content component="h2">Add components</Content>
				</Content>
			</StackItem>
			{productVersionsData?.length === 0 && hasValidated && !hasCertified && (
				<StackItem>
					<Alert
						variant={"info"}
						title={
							"You have added a validated component but have not completed a support statement for" + " your product."
						}
						isInline={true}
						actionLinks={[
							<Button key="support-statement-link" variant={"link"} onClick={goToSupportStatements}>
								Complete support statement
							</Button>,
						]}
					/>
				</StackItem>
			)}
			{activeCertificationListState?.length > 0 && (
				<StackItem>
					<ProductComponentsRequirements />
				</StackItem>
			)}
			<StackItem>
				<ProductComponentsTable
					title={activeCertificationListState?.length > 0 ? "Active Attached Components" : null}
					hideActiveFilter={true}
					isMiniTable={true}
					hideValidatedComponents={true}
				/>
			</StackItem>
			<StackItem>
				<Split hasGutter={true}>
					<SplitItem>
						<Button onClick={goToSupportStatements} variant={"secondary"}>
							Edit support statement
						</Button>
					</SplitItem>
					<SplitItem>
						<Button isDisabled={activeCertificationListState?.length === 0} onClick={onNext} variant={"primary"}>
							Continue to testing
						</Button>
					</SplitItem>
				</Split>
			</StackItem>
		</Stack>
	);
};

export default AddComponents;
